// generated with ChatGPT and adjuested manually
import { supportedLocales, translation, } from '@tymia/main-api';
import { memoize, } from 'micro-memoize';
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function assertParamName(name, pattern) {
    if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(name)) {
        throw new Error(`Invalid param name "${name}" in pattern: ${pattern}`);
    }
}
function parseTanStackPattern(pattern) {
    const tokens = [];
    let text = '';
    let index = 0;
    function pushText() {
        if (text) {
            tokens.push({ type: 'text', value: text });
            text = '';
        }
    }
    while (index < pattern.length) {
        // Optional named param: /posts/{-$category}
        // Embedded optional named param is also accepted:
        // /search/therapists-in-{-$city}
        if (pattern.startsWith('{-$', index)) {
            const end = pattern.indexOf('}', index);
            if (end === -1) {
                throw new Error(`Unclosed optional param in pattern: ${pattern}`);
            }
            const name = pattern.slice(index + 3, end);
            assertParamName(name, pattern);
            pushText();
            tokens.push({ type: 'optionalParam', name });
            index = end + 1;
            continue;
        }
        // Embedded named param: /search/therapists-in-{$city}
        if (pattern.startsWith('{$', index)) {
            const end = pattern.indexOf('}', index);
            if (end === -1) {
                throw new Error(`Unclosed param in pattern: ${pattern}`);
            }
            const name = pattern.slice(index + 2, end);
            pushText();
            if (name === '') {
                tokens.push({ type: 'splat' });
            }
            else {
                assertParamName(name, pattern);
                tokens.push({ type: 'param', name });
            }
            index = end + 1;
            continue;
        }
        // Full-segment named param or splat: /suche/$city or /docs/$
        if (pattern[index] === '$') {
            const match = /^\$([A-Za-z_][A-Za-z0-9_]*)?/.exec(pattern.slice(index));
            if (!match) {
                text += pattern[index];
                index += 1;
                continue;
            }
            pushText();
            if (match[1]) {
                tokens.push({ type: 'param', name: match[1] });
            }
            else {
                tokens.push({ type: 'splat' });
            }
            index += match[0].length;
            continue;
        }
        text += pattern[index];
        index += 1;
    }
    pushText();
    return tokens;
}
function compileTokens(tokens) {
    const compiledTokens = [];
    for (const token of tokens) {
        if (token.type === 'text') {
            compiledTokens.push(token);
            continue;
        }
        if (token.type === 'param') {
            compiledTokens.push({
                type: 'param',
                name: token.name,
                optional: false,
            });
            continue;
        }
        if (token.type === 'splat') {
            compiledTokens.push(token);
            continue;
        }
        let prefix = '';
        const previousToken = compiledTokens[compiledTokens.length - 1];
        // TanStack optional params are commonly their own path segment:
        // /posts/{-$category}
        // In that case, make the preceding slash optional too, so it matches
        // both /posts and /posts/news, and build() does not leave /posts/.
        if (previousToken?.type === 'text' && previousToken.value.endsWith('/')) {
            previousToken.value = previousToken.value.slice(0, -1);
            prefix = '/';
        }
        compiledTokens.push({
            type: 'optionalParam',
            name: token.name,
            prefix,
        });
    }
    return compiledTokens;
}
function compileTanStackPattern(pattern) {
    const tokens = compileTokens(parseTanStackPattern(pattern));
    const capturedTokens = tokens.filter((token) => token.type === 'param' || token.type === 'optionalParam' || token.type === 'splat');
    const regex = new RegExp('^'
        + tokens
            .map(token => {
            if (token.type === 'text') {
                return escapeRegExp(token.value);
            }
            if (token.type === 'splat') {
                return '(.+)';
            }
            if (token.type === 'optionalParam') {
                return `(?:${escapeRegExp(token.prefix)}([^/]+?))?`;
            }
            return '([^/]+?)';
        })
            .join('')
        + '$');
    return {
        pattern,
        match(pathname) {
            const match = regex.exec(pathname);
            if (!match) {
                return undefined;
            }
            const params = {};
            capturedTokens.forEach((token, i) => {
                const value = match[i + 1];
                if (token.type === 'optionalParam' && (value === undefined || value === '')) {
                    return;
                }
                params[token.type === 'splat' ? '_splat' : token.name] = value ?? '';
            });
            return params;
        },
        build(params) {
            return tokens
                .map(token => {
                if (token.type === 'text') {
                    return token.value;
                }
                const name = token.type === 'splat' ? '_splat' : token.name;
                const value = params[name];
                if (token.type === 'optionalParam') {
                    if (value === null || value === undefined || value === '') {
                        return '';
                    }
                    return `${token.prefix}${value}`;
                }
                if (value === null || value === undefined) {
                    throw new Error(`Missing param "${name}" for pattern ${pattern}`);
                }
                return value;
            })
                .join('');
        },
    };
}
const getRules = memoize((locale) => {
    const translations = translation(locale);
    return translations.urls.map(([internal, external]) => ({
        internal: compileTanStackPattern(internal),
        external: compileTanStackPattern(external),
    }));
}, {
    maxSize: 300,
});
export function fromLocalizedUrl(url, locale) {
    for (const loc of locale ? [locale] : supportedLocales()) {
        for (const rule of getRules(loc)) {
            const params = rule.external.match(url.pathname);
            if (params) {
                url.pathname = rule.internal.build(params);
            }
        }
    }
    return url;
}
export function toLocalizedUrl(url, locale) {
    for (const rule of getRules(locale)) {
        const params = rule.internal.match(url.pathname);
        if (params) {
            url.pathname = rule.external.build(params);
            return url;
        }
    }
    return url;
}
//# sourceMappingURL=translatedRoutesRewrite.js.map